(ns hai.admin-ui.users.groups.components
  (:require
   ["react" :as react]
   [field :as-alias field]
   [hai.entity.helpers :as entity]
   [hai.sharing.helper :as sharing]
   [hai.users.helper :as users]
   [hai.ui.components :as c]
   [hai.ui.components.collection.bulk-actions :as bulk-actions]
   [hai.ui.components.card :as card]
   [hai.ui.components.collection.search :as search]
   [hai.ui.components.collection.table :as collection]
   [hai.ui.components.collection.views.cards :as cards]
   [hai.ui.components.form.core :as form]
   [hai.ui.components.form.select.add-or-invite-users :as add-or-invite-users]
   [hai.ui.rf-sugar :refer [>e]]
   [humbleai.belt.dom :as dom]
   [lambdaisland.ornament :as o]))

(o/defstyled render :div
  :flex :flex-col :gap-5
  [:& [:.controls :flex :flex-row :gap-5 :ml-auto]]
  ([{:form/keys [on-submit]
     {:keys [users]} :form/fields}
    on-open]
   [:<>
    [add-or-invite-users/field users]
    [:div.controls
     [c/Button
      {:on-click (fn [_] (on-open false))
       :color "crimson"
       :variant "surface"}
      "Cancel"]
     [c/Button
      {:on-click on-submit}
      "Save"]]]))

(o/defstyled form :div
  :mt-5
  ([table group on-open]
   ;; TODO this is all a hack, see
   ;; `hai.ui.components.form.select.add-or-invite-users/add-users-field*`
   (let [form-id (gensym)]
     [form/component
      ;; TODO does this schema matter?
      {:schema [:map [:users :any]]
       :id form-id
       :render (fn [form] [render form on-open])
       :on-submit (fn [_]
                    (let [selected? (into #{}
                                          (map :user/uuid)
                                          (get-in @re-frame.db/app-db
                                                  [:collections
                                                   [[form-id :users] ::add-or-invite-users/users-field-table-id]
                                                   :table/selected]))
                          users (into []
                                      (filter (comp selected? :user/uuid))
                                      (get-in @re-frame.db/app-db
                                              [:forms
                                               [[form-id :users] ::add-or-invite-users/users-field-table-id]
                                               :form/fields
                                               :table/rows
                                               :form.field/valid-value]))]
                      (>e [:resolve [(list 'group/update
                                           (assoc group :add-members users))]
                           {:on-success (fn [_]
                                          (on-open false)
                                          (>e [:table/resolve table]))}])))}])))

(defn controls*
  [table group]
  (let [[open on-open] (react/useState false)]
    [collection/controls
     [search/component table]
     [bulk-actions/dropdown table]
     (when (sharing/can-edit? group)
       [c/DialogRoot
        {:onOpenChange on-open
         :open open}
        [c/DialogTrigger
         [c/Button
          {:class "add-user"
           :variant "soft"}
          "Add New User"]]
        [c/DialogContent
         {:onInteractOutside dom/stop}
         [c/DialogTitle "Add Team Members"]
         [c/dialog-close-x]
         [c/DialogDescription "Names, Email addresses. Copy/Paste to invite, type to search."]
         [form table group on-open]]])]))

(defn group-members-table
  [group]
  (let [ident (entity/->ident group)]
    [collection/component
     (cond-> {:id [::group-members-table ident]
              :controls (fn [table] [:f> controls* table group])
              :query [{ident [{:group.members/table [{:collection/items users/query}]}]}]
              :paginate? true
              ;; TODO default card render
              :card (fn [collection item]
                      [card/card
                       [cards/card-select-checkbox collection item]
                       [cards/column-render collection item]])
              :columns [{:header "User"
                         :render users/field-render}]}
             (sharing/can-edit? group)
             (assoc :bulk-actions
                    [{:title       "Remove from group"
                      :mutation-fn (fn [entities]
                                     [(list 'group/update
                                            (assoc group :remove-members entities))])}]))]))
